import { render, staticRenderFns } from "./wenzhang-dialog.vue?vue&type=template&id=aab668b2&"
import script from "./wenzhang-dialog.vue?vue&type=script&lang=js&"
export * from "./wenzhang-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports